import * as _Yup from 'yup'

export const Yup = _Yup

export const requiredFieldValidator = Yup.string().required(
  'Обязательно для заполнения'
)

export const phoneValidator = Yup.string()
  .required('Обязательно для заполнения')
  .min(10, 'Пожалуйста, введите корректный номер телефона из 10 цифр')

export const phoneWithFormatValidator = Yup.string()
  .required('Обязательно для заполнения')
  .matches(/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/g, {
    message: 'Пожалуйста введите корректный номер телефона из 10 цифр',
  })

export const emailValidator = Yup.string()
  .required('Обязательно для заполнения')
  .email('Пожалуйста, введите корректный e-mail')

export const passwordValidator = Yup.string().matches(
  /^(?=.*\d)(?=.*[A-zа-яА-ЯёЁ]).{8,}$/,
  {
    message: 'Пароль должен содержать 8+ символов, буквы и цифры',
  }
)

export const ogrnipValidator = Yup.string()
  .required('Обязательно для заполнения')
  .min(15, 'Должен содержать 15 цифр')

export const retryPasswordValidator = (passwordField: string) => {
  return Yup.string()
    .required('Обязательно для заполнения')
    .oneOf([Yup.ref(passwordField)], 'Пароли не совпадают')
}

export const acceptPolicyValidator = Yup.boolean().isTrue(
  'Пожалуйста, согласитесь с Условиями, чтобы зарегистрироваться'
)

export const confirmCodeValidator = Yup.string().length(6).required()

export const acceptTermsValidator = Yup.bool()
  .required()
  .oneOf([true], 'Пожалуйста, согласитесь с Условиями, чтобы продолжить')
